export default __webpack_public_path__ + "static/media/7.f8215432.jpg";